import styled from "styled-components";
import Left from "../../assets/icons/left.svg";
import ShapesSVG from "../../assets/icons/shapes.svg";
import LogoSVG from "../../assets/images/ASDCLogo.png";
import LanguageChanger from "../languageChanger/languageChanger.component";
import { Link } from "react-router-dom";
import LoadingButton from "../loadingButton/loadingButton.component";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: auto;
`;
export const LoginContainer = styled.form`
  display: flex;
  justify-content: center;
  border-radius: 3px;

  @media (min-width: 768px) {
    height: min(752px, 80vh);
    border-radius: 3px;
    padding-right: 2rem;
    body[lang="ar"] & {
      padding-right: 0;
      padding-left: 2rem;
    }
    box-shadow: -9px 11px 23px 27px rgba(0, 0, 0, 0.07);
    background: ${({ theme: { colors } }) => colors.white};
  }
  @media (max-width: 768px) {
    width: 100%;
    min-height: 100vh;
    flex-direction: column;
  }
`;
export const WelcomeContainer = styled.div`
  background: ${({ theme: { colors } }) => colors.primaryDark};
  color: ${({ theme: { colors } }) => colors.white};
  width: 30vw;
  min-width: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 7rem 0;
  justify-content: center;
  position: relative;
  overflow: hidden;
  * {
    z-index: 1;
  }
  @media (max-width: 768px) {
    display: none;
  }

  @media screen and (max-height: 1024px) {
    padding: 0;
  }
`;
export const WelcomeHeader = styled.h1`
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
`;
export const WarningText = styled.p`
  color: ${({ theme: { colors } }) => colors.gray400};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
  width: 60%;
  line-height: 150%; /* 21px */
`;
export const Shapes = styled.img.attrs({ src: ShapesSVG })`
  position: absolute;
  top: -100px;
  z-index: 0;
  left: -65px;
  animation-name: move;
  animation-timing-function: linear;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  @keyframes move {
    from {
      left: -65px;
      top: -100px;
    }
    to {
      left: -30px;
      top: -70px;
    }
  }
`;
export const BackBtn = styled.button`
  display: flex;
  width: 183.116px;
  height: 41.858px;
  padding: 0px 22px;
  justify-content: center;
  align-items: center;
  border-radius: 41px;
  border: 2px solid ${({ theme: { colors } }) => colors.mouve};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: transparent;
  color: white;
  cursor: pointer;
`;
export const BackIcon = styled.img.attrs({ src: Left })`
  margin-right: 1rem;
  body[lang="ar"] & {
    transform: rotate(180deg);
    margin-right: 0rem;
    margin-left: 1rem;
  }
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40vw;
  max-width: 500px;
  position: relative;
  padding: 3rem 0;

  @media (min-width: 768px) {
    margin-left: 2rem;
    body[lang="ar"] & {
      padding-left: 0;
      margin-right: 2rem;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 1.5rem;
  }
`;
export const FormHeader = styled.h1`
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const AdminButton = styled(LoadingButton)`
  display: flex;
  color: white;
  border: none;
  width: 292px;
  height: 58px;
  padding: 0px 22px;
  justify-content: center;
  align-items: center;
  border-radius: 41px;
  background: ${({ theme: { colors } }) => colors.mouve};
  font-size: 1.5rem;
  cursor: pointer;
`;
export const Logo = styled.img.attrs({ src: LogoSVG })`
  width: 200px;
  height: 190px;
`;
export const LanguageChangerBtn = styled(LanguageChanger)`
  position: absolute !important;
  top: 2rem !important;
  right: 1rem !important;
  width: 2rem !important;
  body[lang="ar"] & {
    right: unset;
    left: 1rem;
  }
`;
export const BtnLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme: { colors } }) => colors.white};
  body[lang="ar"] & {
    padding-bottom: 5px;
  }
`;

export const MobileWelcomeContainer = styled.div`
  display: none;
  background: ${({ theme: { colors } }) => colors.primaryDark};
  color: ${({ theme: { colors } }) => colors.white};
  width: 100%;
  padding: 1.5rem;
  flex-direction: column;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MobileVideoContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 1rem 0;

  .video-react {
    margin-top: 1rem;
    width: 100%;
  }
`;

export const MobileContactInfo = styled.div`
  margin-top: 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  
  a {
    color: ${({ theme: { colors } }) => colors.white};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;
